<template>
    <SfPageContainer>
        <ul
            v-show="pathArray.length > 1"
            class="breadcrumb-navigation"
        >
            <template
                v-for="({ path, label }, index) in pathArray"
                :key="`${path}_${index}`"
            >
                <li>
                    <NuxtLink :to="localePath(`/${path}`)">
                        {{ label }}
                    </NuxtLink>
                </li>

                <SfIcon
                    v-if="index !== pathArray.length - 1"
                    icon="chevron-right"
                />
            </template>
        </ul>
    </SfPageContainer>
</template>

<script setup lang="ts">
import SfPageContainer from '~/patterns/organisms/page-container/page-container.vue';
import SfIcon from '~/patterns/atoms/icon/icon.vue';

const props = defineProps<{
    parentPath?: string | null;
}>();

const { parentPath } = toRefs(props);

const route = useRoute();
const localePath = useLocalePath();

const pathArray = computed(() => {
    let parent = parentPath.value;
    let path = route.path;

    // Not the DRY'est approach, but it works 🤷🏻
    if (parent?.startsWith('/en')) {
        parent = parent.replace('/en', '');
    }

    if (path?.startsWith('/en')) {
        path = path.replace('/en', '');
    }

    const parentArray = [
        ...parent ? [parent.slice(1)] : [],
    ].map((p) => ({ path: p, label: p.replaceAll('-', ' ') }));

    const childArray = [
        ...path.slice(1).split('/')
    ].map((p, index) => ({
        path: index === 0 ? p : path.slice(1),
        label: p.replaceAll('-', ' '),
    }));

    return [
        ...parentArray,
        ...childArray
    ];
});
</script>

<style lang="less">
.breadcrumb-navigation {
    .list-clean();

    display: flex;
    align-items: center;

    column-gap: 1rem;

    padding-bottom: var(--spacing-3xl);
}

.sf-hero--overview-page .breadcrumb-navigation {
    padding-bottom: var(--spacing-xl);
}

.breadcrumb-navigation .dn-icon {
    color: var(--color-gray-500);
}

.breadcrumb-navigation li a {
    color: var(--color-gray-500);
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}

.breadcrumb-navigation li:last-of-type a {
    color: var(--color-darkest);
}

[data-color-theme='dark'] {
    .breadcrumb-navigation li a {
        color: var(--color-gray-300);
    }

    .breadcrumb-navigation li:last-of-type a {
        color: var(--color-lightest);
    }
}
</style>
